<div class="button-create" fxLayoutAlign="end">
    <button mat-raised-button color="primary" class="primary-button" (click)="createMarket()" aria-label="Créer un nouveau marché">Créer un nouveau marché</button>
</div>

<app-markets *ngFor="let market of markets" [market]="market" [markets]="markets" (triggerRefresh)="triggerRefresh($event)"></app-markets>